import React, { FC, useState, useEffect } from "react";
import { Button, Row, Col, Result, message, Spin, Alert } from "antd";
import { useFeatureFlags } from "feature-flag-react-lite";
import moment from "moment";
import maintenanceJson from "../utils/maintenanceMessageHelper";


const Maintenance: FC<any> = (props: any) => {
  const [maintenanceMessage, setMaintenanceMessage] = useState<string>("");
  const [
    impendingMaintenanceMessage,
    setImpendingMaintenanceMessage,
  ] = useState<string>("");
  const [
    impendingMessageTimestamp,
    setImpendingMessageTimestamp,
  ] = useState<string>("");
  const [
    maintenanceStartTimestamp,
    setMaintenanceMessageTimestamp,
  ] = useState<string>("");
  const [
    maintenanceEndTimestamp,
    setMaintenanceEndTimestamp,
  ] = useState<string>("");
  const [maintenanceUpcoming, setMaintenanceUpcoming] = useState<string>(
    "false"
  );


  const { GetFeatureFlagByName, FeatureFlagList } = useFeatureFlags();

  useEffect(() => {
    getFeatureFlags();
  }, [FeatureFlagList]);

  const getFeatureFlags = () => {
    setMaintenanceMessage(
      GetFeatureFlagByName("MAINTENANCE_MSG_SYSTEM_UPLOAD_CREDS")
    );
    setImpendingMaintenanceMessage(
      GetFeatureFlagByName("MAINTENANCE_MSG_IMPENDING_UPLOAD_CREDS")
    );
    setImpendingMessageTimestamp(
      GetFeatureFlagByName("MAINTENANCE_MSG_IMPENDING_TIMESTAMP_UPLOAD_CREDS")
    );
    setMaintenanceMessageTimestamp(
      GetFeatureFlagByName("MAINTENANCE_MSG_START_TIMESTAMP_UPLOAD_CREDS")
    );
    setMaintenanceEndTimestamp(
      GetFeatureFlagByName("MAINTENANCE_MSG_END_TIMESTAMP_UPLOAD_CREDS")
    );
    setMaintenanceUpcoming(
      GetFeatureFlagByName("MAINTENANCE_UPCOMING_UPLOAD_CREDS")
    );
  };


  const MaintenanceMessage = () => {
    
      const maintenanceMessageResp: any = maintenanceJson(
        impendingMaintenanceMessage,
        maintenanceMessage,
        impendingMessageTimestamp,
        maintenanceStartTimestamp,
        maintenanceEndTimestamp,
        new Date(),
        maintenanceUpcoming
      );

      if (maintenanceMessageResp?.maintenanceType === "SYSTEM") {

        return (
          <>
            <Row>
              <Col span={24}>
                <Result status="warning" title={""}></Result>
              </Col>
            </Row>
            <div style={{ textAlign: "center" }}>
              <div
                style={{ maxWidth: "400px", display: "inline-block" }}
                dangerouslySetInnerHTML={{
                  __html: maintenanceMessageResp?.maintenanceMsg
                    ? maintenanceMessageResp.maintenanceMsg
                    : "",
                }}
              ></div>
            </div>
          </>
        );
      }
    
    return <>{props.children}</>;
  };

  return (
    <div>
      {maintenanceUpcoming === "true" ? (
        <>
          <MaintenanceMessage />
        </>
      ) : (
        props.children
      )}
    </div>
  );
};

export default Maintenance;
